'use client';

import { useEffect, useState } from 'react';

import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';
import { env } from 'next-runtime-env';

import { userProfileAtom } from '@my-account/Atoms/UserProfile.atom';

import { isFlagminOpenAtom } from '../DevToolsListener';
import type { FlagminModalProps } from './FlagminModal';

const FlagminModal = dynamic(() => import('./FlagminModal').then(mod => mod.FlagminModal));

export const FlagminWrapper = (props: FlagminModalProps) => {
  const isOpen = useAtomValue(isFlagminOpenAtom);
  const { data: userProfile } = useAtomValue(userProfileAtom);

  const [hasBeenOpened, setHasBeenOpened] = useState(false);
  const isProd = env('NEXT_PUBLIC_APP_ENV') === 'prod';

  useEffect(() => {
    if (isProd && !userProfile?.email.includes('@heycar.')) return;
    if (isOpen) setHasBeenOpened(true);
  }, [isOpen]);

  if (hasBeenOpened) return <FlagminModal {...props} />;

  return null;
};
